var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8044 8.04331C13.6609 8.22991 12.4777 8.71515 11.5742 9.71733C10.6509 10.7414 10.0278 12.2962 10.0278 14.5984C10.0278 17.261 9.69634 18.7212 9.15195 19.7006C8.70231 20.5096 8.10639 20.9953 7.40731 21.5652C7.25888 21.6862 7.10579 21.811 6.94847 21.9435L6.7808 22.0847H7H25H25.2178L25.0518 21.9437C24.8922 21.8082 24.7369 21.6807 24.5864 21.5571C23.8935 20.9883 23.3004 20.5013 22.8516 19.6941C22.306 18.7129 21.9722 17.2515 21.9722 14.5891C21.9722 12.2869 21.3527 10.7334 20.4335 9.71097C19.534 8.71047 18.3554 8.22749 17.2143 8.04318C17.2143 8.0408 17.2144 8.03839 17.2144 8.03594C17.2144 7.40817 16.6603 6.92 16 6.92C15.3379 6.92 14.8044 7.40983 14.8044 8.03594L14.8044 8.03904C14.8044 8.04045 14.8044 8.04188 14.8044 8.04331ZM19.3138 9.91095L19.314 9.91111C20.4377 10.8605 21.02 12.4177 21.02 14.5797C21.02 18.3687 21.6684 19.9896 22.7978 21.17H9.21C9.5665 20.7839 9.89259 20.3652 10.1614 19.7936C10.7315 18.5915 10.9847 16.9881 10.9847 14.5938C10.9847 12.4318 11.567 10.8653 12.6953 9.91117C13.7478 9.02414 15.0753 8.83781 16.0094 8.83781C16.9436 8.83781 18.2708 9.02419 19.3138 9.91095ZM18.5122 22.9943L18.5235 22.9044H18.4328H13.5859H13.4957L13.5065 22.994C13.643 24.1197 14.7154 25.08 16.0094 25.08C17.3036 25.08 18.3709 24.1195 18.5122 22.9943Z",
    fill: "#1B1625",
    stroke: "#1B1625",
    strokeWidth: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPreferences);
export default __webpack_public_path__ + "static/media/notification-preferences.9e5f3af0f3f4bcbcc4601906ce52bdf6.svg";
export { ForwardRef as ReactComponent };